import DatabaseModel from './DatabaseModel.js';

/**
 * Adapter NotificacionConfig — endpoints de configuración y logs de
 * notificaciones programadas por dominio.
 *
 * Apunta a /movilidad/notificacion/* (singular). Es DISTINTO de:
 * - Notificacion.js  → /movilidad/notificaciones/* (push y envío directo)
 * - UserNotificacion.js → /movilidad/notificaciones/users/* (por usuario)
 *
 * Los métodos están parametrizados por dominio ('OEB', 'OEB-PRODPLAN' y
 * en el futuro 'OEA'). El backend filtra y organiza por dominio sin
 * necesidad de modelos separados.
 */

var NotificacionConfig = Object.create(DatabaseModel);

NotificacionConfig.model = 'notificacion';

// ============================================================
// Configuraciones por dominio
// ============================================================

/**
 * Las lecturas de este adapter NO pasan por la caché de peticiones (60 s de sendRequest). Las tres
 * pantallas de notificaciones se anuncian como "datos en vivo" (#16) y ahí mismo se crean, activan,
 * eliminan y ejecutan reglas: las mutaciones van por sendRequest sin cache y no limpian la del
 * modelo, así que la recarga posterior devolvería la lista o el log de antes bajo ese sello. Lo
 * mismo al volver a entrar dentro de ese minuto si la regla la tocó otro administrador.
 */
NotificacionConfig.getConfiguraciones = function(dominio) {
    var self = this;
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + '/config/' + encodeURIComponent(dominio),
        method: 'GET'
    }, false);
};

NotificacionConfig.crearConfiguracion = function(datos) {
    var self = this;
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + '/config',
        method: 'POST',
        data: datos
    }, false);
};

NotificacionConfig.toggleConfiguracion = function(id) {
    var self = this;
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + '/config/' + id + '/toggle',
        method: 'PUT',
        data: {}
    }, false);
};

NotificacionConfig.eliminarConfiguracion = function(id) {
    var self = this;
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + '/config/' + id,
        method: 'DELETE'
    }, false);
};

NotificacionConfig.ejecutarAhora = function(id, datos) {
    var self = this;
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + '/ejecutar/' + id,
        method: 'POST',
        data: datos
    }, false);
};

// ============================================================
// Logs por dominio
// ============================================================

NotificacionConfig.getLogs = function(dominio, limit) {
    var self = this;
    var url = self.server_movilidad + self.prefix + self.model + '/logs/' + encodeURIComponent(dominio);
    if (limit) url += '?limit=' + limit;
    // Sin caché de peticiones, por lo mismo que getConfiguraciones: el log tiene que enseñar el
    // envío que se acaba de lanzar con "Enviar ahora", no el de hasta un minuto antes.
    return self.sendRequest({ url: url, method: 'GET' }, false);
};

export default NotificacionConfig;
